import { useIsMobile } from '../hooks/useIsMobile';

export const Scene3D = () => {
  const isMobile = useIsMobile();

  // Mobile: ultra-minimal — just gradient + 1 sphere + 3 particles
  if (isMobile) {
    return (
      <div className="canvas-container" style={{ overflow: 'hidden' }}>
        <div className="absolute inset-0"
          style={{ background: 'radial-gradient(ellipse at center, #2D0A1E 0%, #1A0510 50%, #0A0208 100%)' }}
        />
        <div className="absolute rounded-full animate-drift-slow"
          style={{ width: '200px', height: '200px', background: 'radial-gradient(circle at 30% 30%, #FF69B4 0%, #FF00FF 40%, #8B008B 100%)', opacity: 0.5, top: '15%', left: '-8%' }}
        />
        <div className="absolute rounded-full animate-drift-reverse"
          style={{ width: '140px', height: '140px', background: 'radial-gradient(circle at 40% 40%, #FF1493 0%, #C71585 50%, #8B008B 100%)', opacity: 0.4, top: '55%', right: '-5%' }}
        />
        {[0, 1, 2].map(i => (
          <div key={`p-${i}`} className="absolute rounded-full animate-particle"
            style={{ width: '3px', height: '3px', background: ['#FF00FF', '#FFD1DC', '#CCFF00'][i], left: `${25 + i * 30}%`, top: `${20 + i * 25}%`, animationDelay: `${i}s`, animationDuration: `${4 + i}s` }}
          />
        ))}
        <div className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at center, transparent 0%, rgba(10, 2, 8, 0.4) 70%, rgba(10, 2, 8, 0.8) 100%)' }}
        />
      </div>
    );
  }

  // Desktop: full experience
  return (
    <div className="canvas-container" style={{ overflow: 'hidden' }}>
      <div className="absolute inset-0"
        style={{ background: 'radial-gradient(ellipse at center, #2D0A1E 0%, #1A0510 50%, #0A0208 100%)' }}
      />
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute rounded-full animate-drift-slow will-change-transform"
          style={{ width: '400px', height: '400px', background: 'radial-gradient(circle at 30% 30%, #FF69B4 0%, #FF00FF 40%, #8B008B 100%)', filter: 'blur(2px)', boxShadow: '0 0 100px rgba(255, 0, 255, 0.5)', opacity: 0.8, top: '10%', left: '-10%' }}
        />
        <div className="absolute rounded-full animate-drift-reverse will-change-transform"
          style={{ width: '300px', height: '300px', background: 'radial-gradient(circle at 40% 40%, #FF1493 0%, #C71585 50%, #8B008B 100%)', filter: 'blur(3px)', boxShadow: '0 0 80px rgba(255, 20, 147, 0.4)', opacity: 0.7, top: '50%', right: '-5%' }}
        />
        <div className="absolute rounded-full animate-drift-slow"
          style={{ width: '150px', height: '150px', background: 'radial-gradient(circle at 30% 30%, #00FFFF 0%, #008B8B 100%)', filter: 'blur(5px)', boxShadow: '0 0 50px rgba(0, 255, 255, 0.3)', top: '60%', left: '10%' }}
        />
        <div className="absolute rounded-full animate-drift-reverse"
          style={{ width: '100px', height: '100px', background: 'radial-gradient(circle at 40% 40%, #CCFF00 0%, #9ACD32 100%)', filter: 'blur(4px)', boxShadow: '0 0 40px rgba(204, 255, 0, 0.4)', top: '20%', right: '20%' }}
        />
        <div className="absolute animate-spin-slow will-change-transform"
          style={{ width: '500px', height: '500px', background: 'conic-gradient(from 0deg, #FF00FF, #FF1493, #FFD1DC, #FF69B4, #FF00FF)', borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%', filter: 'blur(40px)', opacity: 0.3, bottom: '-20%', right: '20%' }}
        />
        {[...Array(20)].map((_, i) => (
          <div key={`particle-${i}`} className="absolute rounded-full animate-particle"
            style={{ width: `${2 + (i % 4)}px`, height: `${2 + (i % 4)}px`, background: ['#FF00FF', '#FFD1DC', '#00FFFF', '#CCFF00'][i % 4], left: `${(i * 17 + 5) % 100}%`, top: `${(i * 23 + 10) % 100}%`, animationDelay: `${(i * 0.7) % 5}s`, animationDuration: `${4 + (i % 3) * 2}s`, boxShadow: `0 0 ${4 + (i % 3) * 3}px currentColor` }}
          />
        ))}
      </div>
      <div className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at center, transparent 0%, rgba(10, 2, 8, 0.4) 70%, rgba(10, 2, 8, 0.8) 100%)' }}
      />
    </div>
  );
};

export default Scene3D;
